import * as React from "react";
import { useInitializeOfflineData } from "duck";
import {
  AnestheticProtocolsDocument,
  useDeleteAnestheticProtocolsMutation
} from "requests";
import { SelectionContext } from "../../../../../../../duck";

export const useDelete = () => {
  const { selected, setSelected } = React.useContext(SelectionContext);
  const { loadProtocols } = useInitializeOfflineData();

  const [deleteAnestheticProtocols] = useDeleteAnestheticProtocolsMutation({
    ignoreResults: true
  });

  return {
    onConfirm: () => {
      const ids = selected.map(protocol => protocol._id);

      return deleteAnestheticProtocols({
        variables: { input: { ids } },
        refetchQueries: [AnestheticProtocolsDocument],
        awaitRefetchQueries: true
      }).then(() => {
        setSelected([]);
        loadProtocols();
      });
    },
    names: selected.map(protocol => protocol.name)
  };
};
